import React, {useEffect, useState} from "react";
import {useHistory} from "react-router";
import {useDispatch, useSelector} from "react-redux";
import {useTranslation} from "react-i18next";

//components:
import {Field, Form, Formik} from "formik";
import {CircularProgress} from "@material-ui/core";
import CloudIcon from "@material-ui/icons/Cloud";
import TermsAndConditionsChallenge from "./challenges/TermsAndConditionsChallenge";
import Swal from "sweetalert2";

//redux:
import {setInitialState, tryLogin} from "../../redux_slices/authenticationSlice";
import {loadParameter} from "../../redux_slices/contextSlice";
import {sendDataLayer} from "../../util/tagmanager";

export default ({redirect = false}) => {
    const {t} = useTranslation();

    const {REACT_APP_BACKEND_API_URL} = process.env;

    let [formDisabled, setFormDisabled] = useState(false);

    const contextSelector = useSelector(state => state.context);
    const contextStatus = useSelector(state => state.context.status);
    const authStatus = useSelector(state => state.authentication.status);
    const contextChallenges = useSelector(state => state.authentication.challenges);
    const customTitle = useSelector(state => loadParameter(state, "loginTitle"));
    const customDescription = useSelector(state => loadParameter(state, "loginDescription"));

    const history = useHistory();
    const dispatch = useDispatch();

    useEffect(() => {
        if (authStatus.type === "failed" && authStatus.error) {
            setFormDisabled(true);
            Swal.fire({
                icon: "error",
                text: t(authStatus.error),
            }).then(async result => {
                await dispatch(setInitialState());
                setFormDisabled(false);
            });
        }
    }, [authStatus]);

    const onClickTryCognitoLogin = async () => {
        setFormDisabled(true);
        window.location.replace(`${REACT_APP_BACKEND_API_URL}/cognito`);
    };

    const onSubmitTryLogin = async (values, {resetForm}) => {
        setFormDisabled(true);
        let loginParams = {
            type: "account",
            username: values.username,
            password: btoa(values.password),
        };
        await dispatch(tryLogin(loginParams));
    };
    let container;
    // if (isAuthenticated && authStatus.type === "succeeded") {
    if (authStatus.type === "succeeded") {
        if (contextSelector.credential?.credential_id) {
            sendDataLayer(
                {
                    event: "session_login",
                },
                {context: contextSelector}
            );
        }
        if (contextChallenges && contextChallenges.length) {
            for (let challenge of contextChallenges) {
                switch (challenge.key) {
                    case `termsAndConditions`:
                        container = (
                            <div className="d-flex flex-column-fluid flex-center">
                                <TermsAndConditionsChallenge />
                            </div>
                        );
                        break;
                }
            }
        } else {
            container = (
                <div className="d-flex flex-column-fluid flex-center flex-column">
                    <CircularProgress />
                    <p className="font-weight-bold font-size-h3 mt-4">
                        {contextStatus.type === "loading"
                            ? `${t("AUTH.LOGIN.LOADING")}...`
                            : `${t("AUTH.LOGIN.SUCCEEDED")}!`}
                    </p>
                </div>
            );
            if (redirect) {
                setTimeout(() => history.push("/"), 2000);
            }
        }
    } else if (authStatus.type === "loading" && contextChallenges && contextChallenges.length) {
        container = (
            <div className="d-flex flex-column-fluid flex-center">
                <CircularProgress />
            </div>
        );
    } else {
        container = (
            <div className="d-flex flex-column-fluid flex-center">
                <div className="login-form login-signin">
                    <Formik initialValues={{username: "", password: ""}} onSubmit={onSubmitTryLogin}>
                        <Form>
                            <div className="pb-13 pt-lg-0 pt-5">
                                <h3 className="font-weight-bolder text-dark font-size-h4 font-size-h1-lg">
                                    {customTitle || t("AUTH.LOGIN.TITLE")}
                                </h3>
                                <span className="text-muted font-weight-bold font-size-h4">
                                    {customDescription || t("AUTH.LOGIN.SUBTITLE")}
                                </span>
                            </div>
                            {/*<div className="form-group fv-plugins-icon-container">*/}
                            {/*    <label className="font-size-h6 font-weight-bolder text-dark">*/}
                            {/*        {t("AUTH.LOGIN.USERNAME")}*/}
                            {/*    </label>*/}
                            {/*    <Field*/}
                            {/*        id="username"*/}
                            {/*        name="username"*/}
                            {/*        type="text"*/}
                            {/*        className={"form-control form-control-solid h-auto py-6 px-6 rounded-lg"}*/}
                            {/*        autoComplete="off"*/}
                            {/*        placeholder="username"*/}
                            {/*        disabled={formDisabled || authStatus.type === "loading"}*/}
                            {/*        autoFocus*/}
                            {/*    />*/}
                            {/*</div>*/}
                            {/*<div className="form-group fv-plugins-icon-container">*/}
                            {/*    <label className="font-size-h6 font-weight-bolder text-dark pt-5">*/}
                            {/*        {t("AUTH.LOGIN.PASSWORD")}*/}
                            {/*    </label>*/}
                            {/*    <Field*/}
                            {/*        id="password"*/}
                            {/*        name="password"*/}
                            {/*        type="password"*/}
                            {/*        className={"form-control form-control-solid h-auto py-6 px-6 rounded-lg"}*/}
                            {/*        autoComplete="off"*/}
                            {/*        placeholder="password"*/}
                            {/*        disabled={formDisabled || authStatus.type === "loading"}*/}
                            {/*    />*/}
                            {/*</div>*/}
                            {authStatus.type === "loading" ? (
                                <div className="d-flex flex-column-fluid flex-center">
                                    <CircularProgress />
                                </div>
                            ) : (
                                <div className="pb-lg-0 pb-5">
                                    {/*<button*/}
                                    {/*    type="submit"*/}
                                    {/*    className="btn btn-primary font-weight-bolder font-size-h6 px-8 py-4 my-3 mr-3"*/}
                                    {/*>*/}
                                    {/*    {t("AUTH.LOGIN.BUTTON")}*/}
                                    {/*</button>*/}
                                    <button
                                        type="button"
                                        className="btn btn-light-primary font-weight-bolder px-8 py-4 my-3 font-size-lg"
                                        onClick={() => onClickTryCognitoLogin()}
                                    >
                                        {t("AUTH.LOGIN.BUTTON")}
                                    </button>
                                </div>
                            )}
                        </Form>
                    </Formik>
                </div>
            </div>
        );
    }

    return <div className="w-100">{container}</div>;
};
